/**
 * PWA (Progressive Web App) related constants
 */

/**
 * Google Play Store URL for the CribCritic Android app
 * Package ID: ai.cribcritic
 */
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=ai.cribcritic&pcampaignid=install_popover';

/**
 * Apple App Store URL for the CribCritic iOS app
 * Includes attribution tracking via ct parameter
 */
export const APP_STORE_URL = 'https://apps.apple.com/app/apple-store/id6746699323?pt=128103259&ct=install_popover&mt=8';

/**
 * Android brand colors (official Android green from Google's Material Design)
 * Used for Android-specific UI elements to maintain brand consistency
 */
export const ANDROID_BRAND_COLORS = {
  /** Main Android green (#3DDC84) */
  main: '#3DDC84',
  /** Darker shade for hover state (#2BC470) */
  hover: '#2BC470',
  /** Darkest shade for active/pressed state (#25A75E) */
  active: '#25A75E',
  /** Text color for use on Android green background */
  text: '#1a1a1a',
} as const;

/**
 * iOS brand colors (official Apple blue)
 * Used for iOS-specific UI elements to maintain brand consistency
 */
export const IOS_BRAND_COLORS = {
  /** Main iOS blue (#007AFF) */
  main: '#007AFF',
  /** Darker shade for hover state (#0051D5) */
  hover: '#0051D5',
  /** Darkest shade for active/pressed state (#0040A8) */
  active: '#0040A8',
  /** Text color for use on iOS blue background */
  text: '#FFFFFF',
} as const;
